module.exports = __webpack_public_path__ + "static/media/wod.669a97ab.jpg";